import {Fragment} from "react";
import {StyledCheckbox, StyledInputBox} from "../helpers/styles";
import React from "react";
import {withI18n} from "react-i18next";
import {connect} from "react-redux";
// @ts-ignore
import { CWBDropdown } from "cwb-react";
import {RouteComponentProps} from "react-router-dom";
import styled from "styled-components";
import {components} from "react-select";

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t: any
}

interface IState {
  newRoleInfo?: any,
  roleSelectAll: any
}

class TeamShareRowComponent extends React.Component<IProps, IState> {
  public state: IState = {
    newRoleInfo: {},
    roleSelectAll: {}
  };

  checkValidations = (): any => {
    const { requestData, t } = this.props;
    const {newRoleInfo} = this.state;
    let errors: any = {};
    let formIsValid = true;

    if (!newRoleInfo.roleName) {
      formIsValid = false;
      errors["roleName"] = t("Role Name is required");
    }
    if(requestData.bdType === "2" && !newRoleInfo.spotRId) {
      formIsValid = false;
      errors["spot"] = t("Please select a spot");
    } else if (requestData.bdType !== "2" && !newRoleInfo.roleTypeId) {
      formIsValid = false;
      errors["roleType"] = t("Please select a role type");
    }
    this.props.setErrors(errors)
    return formIsValid;
  }

  commercialModal = () => {
    const { roleSpots, errors, t } = this.props;
    const Option = (props: any) => {
      if (props.data.addNew) {
        return <components.Option {...props}><OptionsFooter className="no-padding">{'Create New Spot'}</OptionsFooter></components.Option>;;
      }
      return <components.Option {...props}>{props.data.label}</components.Option>;
    };
    return <div key={"commercial_modal"}>
      <Content>
        <Label>{t('Role Name')}</Label>
        <div>
          <StyledInputBox type="text" onChange={(e) =>  this.setState({newRoleInfo: {...this.state.newRoleInfo, roleName: e.target.value}})}/>
          {errors && <ErrorText>{errors.roleName}</ErrorText>}
        </div>
      </Content>
      <Content>
        <Label>{t('Spot')}</Label>
        <div>
          <CWBDropdown
              className="modal-dropdown"
              placeholder={t("Select")}
              items={roleSpots || []}
              onChange={async (option: any) => {
                if (option.value === -1)
                  await this.setState({newRoleInfo: {...this.state.newRoleInfo, spotRId: option.value, isNewSpot: true}})
                else
                  await this.setState({newRoleInfo: {...this.state.newRoleInfo, spotRId: option.value, isNewSpot: false}})
                await this.checkValidations();
              }}
              components={{ Option }}
          />
          {errors && <ErrorText>{errors.spot}</ErrorText>}
        </div>
      </Content>
    </div>
  }

  roleModal = () => {
    const { errors, t } = this.props;
    return <div>
      <Content>
        <Label>{t('Role Name')}</Label>
        <div>
          <StyledInputBox type="text" onChange={(e) => this.setState({newRoleInfo: {...this.state.newRoleInfo, roleName: e.target.value}})}/>
          <ErrorText>{errors.roleName}</ErrorText>
        </div>
      </Content>
      <Content>
        <Label>{this.props.t('Role Type')}</Label>
        <div>
          <CWBDropdown
              className="modal-dropdown"
              placeholder={t("Select")}
              items={this.props.roleTypes || []}
              onChange={(option: any) => this.setState({newRoleInfo: {...this.state.newRoleInfo, roleTypeId: option.value}})}
          />
          <ErrorText>{errors.roleType}</ErrorText>
        </div>
      </Content>
      <Content>
        <Label>{t('Gender')}</Label>
        <CWBDropdown
            className="modal-dropdown"
            placeholder={this.props.t("Select")}
            items={this.props.genders || []}
            onChange={(option: any) => this.setState({newRoleInfo: {...this.state.newRoleInfo, genderId: option.value}})}
        />
      </Content>
    </div>
  }


  openRoleModal = (sourceRoleId: number) => {
    const { requestData, openModal, closeModal, selectedTsInfo, setTSInfo, bdRoles, t } = this.props;
    const RenderCommercialRoleModal = () => this.commercialModal()
    const RenderRoleModal = () => this.roleModal()
    openModal({
      className: 'create-role-modal',
      title: t('Create a new Role'),
      message: '',
      children: (requestData.bdType === "2" ? <RenderCommercialRoleModal /> : <RenderRoleModal />),
      onConfirm: () => {
        if(this.checkValidations()) {
          selectedTsInfo.roles.forEach((role: any) => {
            if (role.sourceRoleId === sourceRoleId) {
              role.targetRoleId = -1;
              role.isNewRole = true;
              role.newRoleData = {...this.state.newRoleInfo}
            }
          });
          setTSInfo(selectedTsInfo);

          bdRoles.push({
            label: this.state.newRoleInfo.roleName,
            value: -1,
            ...this.state.newRoleInfo
          });
          closeModal();
          this.props.setErrors(null);
        }
      },
      onCancel: () => {closeModal(); this.props.setErrors(null)},
    })
  }

  setChoices = async (role: any, choiceLevelId: any) => {
    const { selectedTsInfo, setTSInfo } = this.props;
    const index = role.options.indexOf(role.options.find((option: any) => option.choiceLevelId === choiceLevelId))
    index > -1 ? role.options.splice(index, 1) : role.options.push({choiceLevelId: choiceLevelId});
    await setTSInfo(selectedTsInfo);
  }

  selectAllChoices = async (role: any) => {
    role.choices.forEach((choice: any) => {
      role.options.push({choiceLevelId: choice.choiceLevelId});
    })
  }

  render() {
    const { selectedTsInfo, setTSInfo, bdRoles, roleChoices, t } = this.props;

    const MenuList = (props: any) => {
      return (
          <Fragment>
            <components.MenuList {...props}>{props.children}</components.MenuList>
            <OptionsFooter onClick={() => this.openRoleModal(props.options[0].sourceRoleId)}>
              {t('Add a new role')}
            </OptionsFooter>
          </Fragment>
      );
    };

    return  <Fragment>
      {selectedTsInfo.roles.map((role: any, index: number) => {
        let customOptions = [...bdRoles].map((opt: any) => ({...opt, sourceRoleId: role.roleId}))
        return <tr key={`${selectedTsInfo.teamShareId}_row_${index}`}>
          <td className="from-col"><RoleNameCell>{role.roleName}</RoleNameCell></td>
          <td className="to-col">
            <CWBDropdown
                isClearable={true}
                className="to-dropdown"
                placeholder={t("Select")}
                items={customOptions}
                getOptionLabel={(option: any) => option.label || option.roleName}
                value={role.targetRoleId === -1 ? role.newRoleData : customOptions.find((bdRole: any) => bdRole.value === role.targetRoleId)}
                onChange={(option: any) => {
                  if (option && (option.value > 0 || option.value === -1)) {
                    role.targetRoleId = option.value;
                    if (option.value === -1) {
                      role.isNewRole = true;
                      role.newRoleData = option;
                    }
                  } else {
                    role.targetRoleId = -1;
                    role.isNewRole = false;
                    role.newRoleData = null;
                  }
                  setTSInfo(selectedTsInfo);
                }}
                noOptionsMessage={() => t('No role found')}
                components={{ MenuList }}
            />
          </td>
          <td><ul>
            {selectedTsInfo.reportColumns && selectedTsInfo.reportColumns.map((col: any, index:number) => {
              return <li key={`${selectedTsInfo.teamShareId}_${index}`}>
                <Fragment>
                  {col.choiceLevelId === -1
                      ? <StyledCheckbox key={`${role.roleId}_no_choice`}
                              isChecked={role.options.indexOf(role.options.find((option: any) => option.choiceLevelId === -1)) > -1}
                              onClick = {() => this.setChoices(role, -1)}
                        />
                      : <Fragment>
                        {role.choices.map((choice: any) => {
                          return choice.choiceLevelId === col.choiceLevelId
                              ? <StyledCheckbox key={`${role.roleId}_${choice.choiceLevelId}`}
                                  isChecked={role.options.indexOf(role.options.find((option: any) => option.choiceLevelId === choice.choiceLevelId)) > -1}
                                  onClick = {() => this.setChoices(role, choice.choiceLevelId)}
                              /> : ''
                        })}
                      </Fragment>}
                </Fragment>
              </li>
            })}
            {roleChoices[role.roleId] && <li>
              <StyledCheckbox key={`${role.roleId}_select_all`} isChecked={this.state.roleSelectAll[role.roleId]}
                  onClick = {async () => {
                    role.options = [];
                    let roleSelectAll: any = {};
                    roleSelectAll[role.roleId] = !this.state.roleSelectAll[role.roleId];
                    await this.setState({roleSelectAll: {...this.state.roleSelectAll, ...roleSelectAll}});
                    if (roleSelectAll[role.roleId]) this.selectAllChoices(role)
                    await setTSInfo(selectedTsInfo);
                  }}
              />
            </li>}
          </ul></td>
        </tr>
      })}
    </Fragment>
  }
}

const RoleNameCell = styled.div`
  color: ${p => p.theme.grey} !important;
  font-weight: ${p => p.theme['font-weight-600']};
  letter-spacing: 0.44px;
  line-height: 24px;
  padding: 16px 0 16px 16px;
  
  max-width: 220px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  
  @media all and (max-width: 1040px) {
    max-width: 110px;
  }
  
  @media all and (max-width: 720px) {
     min-width: 50px;
  }
`

const Content = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  
  margin: 16px 0;
  &:first-child{
    margin-top: 8px;
  }
  &:last-child{
    margin-bottom: 8px;
  }
`

const OptionsFooter = styled.div`
  font-size: ${props => props.theme['xs-font-size']} !important;
  font-weight: ${props => props.theme['font-weight-600']};
  color: ${props => props.theme.darkBlue} !important;
  padding: 10px 12px;
  border-top: ${props => props.theme.border};
  cursor: pointer;
  
  &.no-padding{
    padding: 0;
    border-top: 0;
  }
`;

const Label = styled.div`
  font-size: ${props => props.theme['xs-font-size']} !important;
  font-weight: ${props => props.theme['font-weight-600']};
  color: ${props => props.theme.grey} !important;
	letter-spacing: 0.11px;
	line-height: 17px;
  min-width: 102px;
  margin-right: 24px;
  text-align: right;
`

const ErrorText = styled.div`
  color: ${p => p.theme.errorColor} !important;
  width: 100%;
  font-size: ${p => p.theme['xxs-font-size']};
  font-weight: ${p => p.theme['font-weight-600']};
  letter-spacing: 0.21px;
  line-height: 15px;
  margin-top: 8px;
  text-align: left;
`

interface StateProps {
  requestData: any,
  selectedTsInfo: any,
  bdRoles: any,
  roleTypes: any,
  genders: any,
  roleSpots: any,
  roleChoices: any,
  errors: any
}

function mapStateToProps(state: any, ownProps: any): StateProps {
  return {
    requestData: state.scheduling.requestData,
    selectedTsInfo: state.scheduling.selectedTsInfo[ownProps.teamShareId],
    bdRoles: state.scheduling.bdRoles,
    roleTypes: state.scheduling.roleTypes,
    genders: state.scheduling.genders,
    roleSpots: state.scheduling.roleSpots,
    roleChoices: state.scheduling.roleChoices,
    errors: state.modal.errors
  };
}

interface DispatchProps {
  closeModal: () => void,
  openModal: ({className, title, message, onConfirm, onCancel, children, buttons}: any) => void,
  openConfirmModal: ({title, message, onConfirm, onCancel, buttons}: any) => void,
  setTSInfo: (header?: any, teamShare?: any, scheduling?: any) => void,
  removeTeamShare: (teamShareId: any) => void,
  setNewRole: ({newRoleInfo, isCommercial}: any) => void,
  setErrors: (errors: any) => void
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    openModal: dispatch.modal.openModal,
    openConfirmModal: dispatch.modal.openConfirmModal,
    closeModal: dispatch.modal.closeModal,
    setTSInfo: dispatch.scheduling.setTSInfo,
    removeTeamShare: dispatch.scheduling.removeTeamShare,
    setNewRole: dispatch.scheduling.setNewRole,
    setErrors: dispatch.modal.setErrors
  };
}

export default withI18n()(connect<StateProps, DispatchProps, {}>(mapStateToProps, mapDispatchToProps)(TeamShareRowComponent));
